import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";

import FreeUser from "./FreeUser";
import NonUpgradableSubscriber from "./NonUpgradableSubscriber";
import UpgradableSubscriber from "./UpgradableSubscriber";
import Download from "./Download";

import { PUBLIC_PROFILE } from "data/links";

const IconCollectionBuyBox = ({
    userSubscriptionType,
    collectionName,
    creatorName,
    creatorCountry,
    creatorAvatarUrl,
    creatorUsername,
    totalIconCount,
    isNewCreativeProSubscriber = false,
    setBuyBoxHeight
}) => {
    const buyBoxRef = useRef(null);

    useEffect(() => {
        const buyBoxHeightObserver = new ResizeObserver(entries => {
            setBuyBoxHeight(entries[0].contentRect.height);
        });

        buyBoxHeightObserver.observe(buyBoxRef.current);

        return () =>
            buyBoxRef.current &&
            buyBoxHeightObserver.unobserve(buyBoxRef.current);
    }, []);

    const creatorProfilePath = PUBLIC_PROFILE.replace(
        ":username",
        encodeURIComponent(creatorUsername)
    );

    const props = {
        collectionName,
        creatorName,
        creatorCountry,
        creatorAvatarUrl,
        totalIconCount,
        creatorProfilePath,
        isNewCreativeProSubscriber
    };

    let buyBox = null;

    if (userSubscriptionType === "none") {
        buyBox = <FreeUser {...props} />;
    }

    if (userSubscriptionType === "team" || userSubscriptionType === "edu") {
        buyBox = <NonUpgradableSubscriber {...props} />;
    }

    if (userSubscriptionType === "individual_pro") {
        buyBox = <UpgradableSubscriber {...props} />;
    }

    if (userSubscriptionType === "creative_pro") {
        buyBox = <Download {...props} />;
    }

    return <div ref={buyBoxRef}>{buyBox}</div>;
};

IconCollectionBuyBox.propTypes = {
    userSubscriptionType: PropTypes.oneOf([
        "none",
        "individual_pro",
        "team",
        "edu",
        "creative_pro"
    ]),
    isNewCreativeProSubscriber: PropTypes.bool
};

export default IconCollectionBuyBox;
